import type { FunctionComponent } from 'react';

import { Spinner } from '@trello/nachos/spinner';
import { EditorTestIds } from '@trello/test-ids';

import styles from './LoadingSpinner.less';

export const LoadingSpinner: FunctionComponent = () => {
  return (
    <Spinner
      centered
      wrapperClassName={styles.loading}
      testId={EditorTestIds.LoadingSpinner}
    />
  );
};
